import { render } from "./Home.vue?vue&type=template&id=ea395d70&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ea395d70&lang=scss&scoped=true"

import exportComponent from "/Users/songlian/Developer/官網/配音工會/taipei-sound-recording/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea395d70"]])

export default __exports__